import styles from "./notification-card.module.css";

import { useState } from "react";

import { Flex, Button, Typography, Tag, Tooltip } from "antd";

import DotCircleEmpty from "@/icons/DotCircleEmpty";
import DotCircleFull from "@/icons/DotCircleFull";
// import SettingsIcon from "@/icons/SettingsIcon";
// import DotsHorizontalIcon from "@/icons/DotsHorizontalIcon";

import EmployeeProfile from "@/components/cards/EmployeeProfile";

import { formateISODateToMoment } from "@/utils";

const NotificationCard = ({
  data,
  className,
  showBan = false,
  onClose,
  onBan,
  onUnread,
  size = "default",
  employees = null,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Flex
      vertical
      gap={8}
      style={{ padding: 10 }}
      className={`${styles.card} ${
        size === "small" ? styles.hoverable : ""
      } ${className}`}
      onClick={() => {
        if (size === "small") {
          setIsOpen(!isOpen);
        }
      }}
    >
      <Flex justify="space-between" align="center">
        <div className={styles.date}>
          {formateISODateToMoment(data.created_at)}
        </div>

        <Flex gap={8} align="center">
          {/* <Dropdown
            menu={{
              items: [
                {
                  key: "read",
                  label: (
                    <Flex gap={8} align="center">
                      <MailOpenIcon
                        style={{ fontSize: 16, color: "#BBBBBB" }}
                      />
                      Отметить прочитанным
                    </Flex>
                  ),
                },
                {
                  key: "hide",
                  label: (
                    <Flex gap={8} align="center">
                      <BanIcon style={{ fontSize: 16, color: "#BBBBBB" }} />
                      Скрыть такие уведомления
                    </Flex>
                  ),
                },
                {
                  key: "settings",
                  label: (
                    <Flex gap={8} align="center">
                      <SettingsIcon
                        style={{ fontSize: 16, color: "#BBBBBB" }}
                      />
                      Перейти к настройкам
                    </Flex>
                  ),
                },
              ],
            }}
            placement="bottomRight"
          >
            <Button
              color="default"
              variant="text"
              type="text"
              size="small"
              icon={<DotsHorizontalIcon style={{ fontSize: 18 }} />}
              style={{ padding: 0 }}
            />
          </Dropdown> */}

          {/* {showBan && (
            <Tooltip title="Скрыть такие уведомления" zIndex={3000}>
              <Button
                color="default"
                variant="link"
                size="small"
                icon={<BanIcon style={{ fontSize: 18 }} />}
                style={{ padding: 0 }}
                onClick={(e) => {
                  e.stopPropagation();
                  onBan();
                }}
                className={styles.mail_btn}
              />
            </Tooltip>
          )} */}

          {data.is_read ? (
            <Tooltip title="Отметить непрочитанным" zIndex={3000}>
              <Button
                color="default"
                variant="link"
                size="small"
                icon={<DotCircleEmpty style={{ fontSize: 18 }} />}
                onClick={(e) => {
                  e.stopPropagation();
                  onUnread();
                }}
                className={styles.mail_btn}
              />
            </Tooltip>
          ) : (
            <Tooltip title="Отметить прочитанным" zIndex={3000}>
              <Button
                color="default"
                variant="link"
                size="small"
                icon={
                  <DotCircleFull style={{ fontSize: 18, color: "#E66A25" }} />
                }
                onClick={(e) => {
                  e.stopPropagation();
                  onClose();
                }}
                className={styles.mail_btn}
              />
            </Tooltip>
          )}
        </Flex>
      </Flex>
      <Typography.Text className={styles.title}>
        {data.title || data.info?.action_display}
      </Typography.Text>

      {data.content && data.content !== data.title && (
        <Typography.Paragraph className={styles.text} style={{ margin: 0 }}>
          {data.content}
        </Typography.Paragraph>
      )}

      <Flex gap={5} vertical className={styles.content}>
        {data.object?.object_number && (
          <Typography.Text className={styles.objectNumber}>
            Задача {data.object.object_number}
          </Typography.Text>
        )}

        {data.object?.object_link ? (
          <a // Используем <a>, а не CustomLink, потому что Link пытается использовать контекст
            href={data.object.object_link}
            onClick={(e) => {
              e.stopPropagation();
              onClose?.();
            }}
            className={styles.objectName}
            style={{ color: "#777777" }}
          >
            {data.object.object_name}
          </a>
        ) : (
          <Typography.Text className={styles.objectName}>
            {data.object?.object_name}
          </Typography.Text>
        )}

        {data.object?.object_type !== "unit" &&
          data.unit?.name &&
          (size === "default" || isOpen) && (
            <>
              <Typography.Text className={styles.unit}>
                Рабочая группа
              </Typography.Text>
              <Typography.Text className={styles.unitName}>
                {data.unit.name}
              </Typography.Text>
            </>
          )}
      </Flex>

      {(size === "default" || isOpen) && (
        <>
          <Flex justify="space-between" align="center">
            {data.object_type?.object_type_display && (
              <Tag>{data.object_type.object_type_display}</Tag>
            )}
          </Flex>

          {data.info?.change_author?.lastname && (
            <EmployeeProfile
              {...data.info.change_author}
              fullName={false}
              avatarSize={20}
              employeesData={employees}
            />
          )}
        </>
      )}
    </Flex>
  );
};

export default NotificationCard;
